import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message
import UIAvatar from 'ui-addon-avatars/UIAvatar';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIIconButton from 'UIComponents/button/UIIconButton';
import UIMultiColumnGroup from 'UIComponents/layout/UIMultiColumnGroup';
import UIMultiColumnItem from 'UIComponents/layout/UIMultiColumnItem';
import UIFlex from 'UIComponents/layout/UIFlex';
import { formatFullNameAndEmailSeperately } from '../../utils/UserUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SelectedUserOption = ({
  id,
  email,
  canRemoveUser,
  disallowedUserTooltip,
  onRemoveUser,
  selectedUserInfo,
  user
}) => {
  const {
    userBadge
  } = selectedUserInfo && selectedUserInfo[id] || {};
  const {
    formattedEmail,
    formattedFullName
  } = formatFullNameAndEmailSeperately(user);
  const displayName = formattedFullName || formattedEmail;
  const maybeDisplayEmailFollowingFullName = formattedFullName ? formattedEmail : null;
  return /*#__PURE__*/_jsxs(UIMultiColumnGroup, {
    style: {
      height: '70px'
    },
    children: [/*#__PURE__*/_jsx(UIMultiColumnItem, {
      children: /*#__PURE__*/_jsxs(UIFlex, {
        align: 'center',
        children: [/*#__PURE__*/_jsx(UIAvatar, {
          size: "sm",
          displayName: email,
          className: "m-right-4",
          lookup: {
            type: 'hubSpotUserEmail',
            primaryIdentifier: email
          }
        }), /*#__PURE__*/_jsxs(UIFlex, {
          align: 'start',
          direction: 'column',
          className: "m-top-0",
          children: [/*#__PURE__*/_jsxs("div", {
            children: [displayName, userBadge]
          }), maybeDisplayEmailFollowingFullName]
        })]
      })
    }), /*#__PURE__*/_jsx(UIMultiColumnItem, {
      children: /*#__PURE__*/_jsx(UIIconButton, {
        "data-test-id": `remove-user-button-${id}`,
        tooltip: canRemoveUser ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ui-asset-management-lib.tooltips.removeUser"
        }) : disallowedUserTooltip && /*#__PURE__*/_jsx(FormattedMessage, {
          message: disallowedUserTooltip
        }),
        size: "extra-small",
        use: "transparent",
        disabled: canRemoveUser === undefined ? false : !canRemoveUser,
        onClick: () => onRemoveUser(id),
        children: /*#__PURE__*/_jsx(UIIcon, {
          name: "remove"
        })
      })
    })]
  });
};
SelectedUserOption.propTypes = {
  id: PropTypes.number.isRequired,
  email: PropTypes.string.isRequired,
  onRemoveUser: PropTypes.func.isRequired,
  selectedUserInfo: PropTypes.object
};
export default SelectedUserOption;